// import Home from "./pages/Home.jsx";
// import Schools from "./pages/Schools.jsx";
// import Corporate from "./pages/Corporate.jsx";
// import ClientSection from "./components/ClientSection.jsx";
// import TestimonialSection from "./components/TestimonialSection.jsx";
// import PrivacyPolicyModal from "./components/PrivacyPolicyModal.jsx";
// import TermsConditionModal from "./components/TermsConditionModal.jsx";
// import { useState, useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import Cookies from "js-cookie";
// import { jwtDecode } from "jwt-decode";

// // Import CSS files
// import "./assets/css/bootstrap.min.css";
// import "./assets/css/style.css";
// import "./assets/css/responsive.css";
// import useHttp from "../Hooks/use-http.js";

// export default function LandingPage() {
//   useEffect(() => {
//     // Add class to body when landing page is mounted
//     document.body.classList.add("landing-page-active");

//     // Cleanup: remove class when component unmounts
//     return () => {
//       document.body.classList.remove("landing-page-active");
//     };
//   }, []);

//   return (
//     <div className="landingPage">
//       <Header />
//       {/* Single-page content: render sections sequentially */}
//       <Home />
//       <Corporate />
//       <Schools />
//       <ClientSection />
//       {/* <TestimonialSection /> */}
//       <ContactForm />
//       <Footer />
//       <FloatingChatWidget />
//       <PrivacyPolicyModal />
//       <TermsConditionModal />
//     </div>
//   );
// }

// function Header() {
//   const history = useHistory();

//   // Helper function to check if token is valid
//   const isTokenValid = () => {
//     const token = Cookies.get("token");
//     if (!token) {
//       return false;
//     }
//     try {
//       const decoded = jwtDecode(token);
//       const currentTime = Date.now() / 1000;
//       return decoded.exp >= currentTime;
//     } catch (error) {
//       console.error("Invalid token", error);
//       return false;
//     }
//   };

//   // Handle Corporate Login click
//   const handleCorporateLoginClick = (e) => {
//     e.preventDefault();
    
//     // Check if token exists and is valid
//     if (isTokenValid()) {
//       // Token is valid, redirect to dashboard
//       // routes.js will handle redirecting to firstUrl if available after login check
//       history.push("/dashboard");
//     } else {
//       // No token or token expired, go to login page
//       // Set flag to indicate user came from landing page
//       sessionStorage.setItem("cameFromLanding", "true");
//       history.push("/login");
//     }
//   };

//   return (
//     <header className="page-header">
//       <div className="container">
//         <div className="header-row align-items-center">
//           <div className="page-header-top">
//             <div className="page-header-logo">
//               <a
//                 href="#BannerSection"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   document.body.classList.remove("show-home-only");
//                   document.body.classList.add("show-all-sections");
//                   // Scroll to top of page
//                   window.scrollTo({ top: 0, behavior: "smooth" });
//                   // Reset banner carousel to first slide
//                   const bannerCarousel =
//                     document.getElementById("bannerCarousel");
//                   if (bannerCarousel) {
//                     // Reset to first slide
//                     bannerCarousel.style.transform = "translateX(0%)";
//                     // Trigger a custom event to reset the carousel state
//                     const resetEvent = new CustomEvent("resetBannerCarousel");
//                     bannerCarousel.dispatchEvent(resetEvent);
//                   }
//                 }}
//               >
//                 <img
//                   src="/assets/images/Logo.png"
//                   className="img-fluid main-logo"
//                   alt=""
//                 />
//               </a>
//             </div>

//             <div
//               className="page-header-toggle"
//               onClick={() => {
//                 document
//                   .getElementById("navigation")
//                   ?.classList.toggle("navigation-visible");
//               }}
//             >
//               ☰
//             </div>
//           </div>
//           <nav className="page-header-bottom">
//             <div className="header-right">
//               <ul id="navigation" className="navigation">
//                 <li className="navigation-item">
//                   <a
//                     href="#BannerSection"
//                     onClick={(e) => {
//                       e.preventDefault();
//                       document.body.classList.remove("show-home-only");
//                       document.body.classList.add("show-all-sections");
//                       // Scroll to top of page
//                       window.scrollTo({ top: 0, behavior: "smooth" });
//                       // Reset banner carousel to first slide
//                       const bannerCarousel =
//                         document.getElementById("bannerCarousel");
//                       if (bannerCarousel) {
//                         // Reset to first slide
//                         bannerCarousel.style.transform = "translateX(0%)";
//                         // Trigger a custom event to reset the carousel state
//                         const resetEvent = new CustomEvent(
//                           "resetBannerCarousel"
//                         );
//                         bannerCarousel.dispatchEvent(resetEvent);
//                       }
//                     }}
//                   >
//                     Home
//                   </a>
//                 </li>
//                 <li className="navigation-item">
//                   <a
//                     href="#AboutSection"
//                     onClick={() => {
//                       document.body.classList.remove("show-home-only");
//                       document.body.classList.add("show-all-sections");
//                     }}
//                   >
//                     About Us
//                   </a>
//                 </li>
//                 <li className="navigation-item">
//                   <a
//                     href="#corporateSection"
//                     onClick={(e) => {
//                       e.preventDefault();
//                       document.body.classList.remove("show-home-only");
//                       document.body.classList.add("show-all-sections");
//                       // Scroll to Corporate section
//                       const corporateSection =
//                         document.getElementById("corporateSection");
//                       if (corporateSection) {
//                         corporateSection.scrollIntoView({ behavior: "smooth" });
//                       }
//                     }}
//                   >
//                     Corporate Commuter
//                   </a>
//                 </li>
//                 <li className="navigation-item">
//                   <a
//                     href="#busbuddySection"
//                     onClick={() => {
//                       document.body.classList.remove("show-home-only");
//                       document.body.classList.add("show-all-sections");
//                     }}
//                   >
//                     BusBuddy
//                   </a>
//                 </li>
//                 <li className="navigation-item">
//                   <a
//                     href="#clientSection"
//                     onClick={() => {
//                       document.body.classList.remove("show-home-only");
//                       document.body.classList.add("show-all-sections");
//                     }}
//                   >
//                     Clients
//                   </a>
//                 </li>
//                 {/* Testimonial */}
//                 {/* <li className="navigation-item">
//                   <a
//                     href="#testimonialSection"
//                     onClick={() => {
//                       document.body.classList.remove("show-home-only");
//                       document.body.classList.add("show-all-sections");
//                     }}
//                   >
//                     Testimonials
//                   </a>
//                 </li> */}

//                 <li className="navigation-item">
//                   <a
//                     href="#contactFormSection"
//                     onClick={() => {
//                       document.body.classList.remove("show-home-only");
//                       document.body.classList.add("show-all-sections");
//                     }}
//                   >
//                     Contact Us
//                   </a>
//                 </li>
//                 {/* <li className="navigation-item"><a href="#registerSection">Register</a></li> */}

//                 <a
//                   href="/login"
//                   className="header-button"
//                   onClick={handleCorporateLoginClick}
//                 >
//                   Corporate Login
//                 </a>
//               </ul>
//               <div className="header-btn"></div>
//             </div>
//           </nav>
//         </div>
//       </div>
//     </header>
//   );
// }

// function Footer() {
//   return (
//     <footer className="site-footer">
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-lg-3 col-md-4 col-sm-12">
//             <div className="footer-logo">
//               <img
//                 src="/assets/images/footer-logo.png"
//                 className="img-fluid"
//                 alt="Little Logo"
//               />
//             </div>
//           </div>
//           <div className="col-lg-9 col-md-8 col-sm-12">
//             <div className="footer-content">
//               {/* <div className="footer-social">
//                 <ul>
//                   <li><a href="#" title="Facebook">
//                     <svg xmlns="http://www.w3.org/2000/svg" width="12" height="21" viewBox="0 0 12 21" fill="none"><path d="M7.69928 20.2008V11.0303H10.7902L11.2542 7.43998H7.69928V5.15522C7.69928 4.11705 7.98635 3.41314 9.47282 3.41314H11.3565V0.212125C11.0301 0.168868 9.90539 0.0705566 8.59588 0.0705566C5.86283 0.0705566 3.99098 1.73792 3.99098 4.8013V7.44391H0.911865V11.0342H3.99098V20.2008H7.69928Z" fill="#353A3B"/></svg>
//                   </a></li>
//                   <li><a href="#" title="Instagram">
//                     <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M10.1342 0.0666504C7.40117 0.0666504 7.05905 0.0784478 5.98549 0.125637C4.91193 0.176759 4.18442 0.345855 3.54343 0.593599C2.88278 0.849209 2.32044 1.19527 1.7581 1.75367C1.19576 2.31208 0.853634 2.87442 0.598024 3.53901C0.35028 4.18 0.181184 4.91144 0.130062 5.98106C0.0789404 7.05462 0.0710754 7.39675 0.0710754 10.1298C0.0710754 12.8629 0.0828728 13.205 0.130062 14.2785C0.181184 15.3482 0.35028 16.0796 0.598024 16.7206C0.853634 17.3813 1.19969 17.9436 1.7581 18.5059C2.31651 19.0643 2.87885 19.4104 3.54343 19.666C4.18442 19.9138 4.91586 20.0829 5.98549 20.134C7.05905 20.1851 7.40117 20.193 10.1342 20.193C12.8673 20.193 13.2094 20.1812 14.283 20.134C15.3526 20.0829 16.084 19.9138 16.725 19.666C17.3857 19.4104 17.948 19.0643 18.5104 18.5059C19.0688 17.9475 19.4148 17.3852 19.6704 16.7206C19.9182 16.0796 20.0873 15.3482 20.1384 14.2785C20.1895 13.205 20.1974 12.8629 20.1974 10.1298C20.1974 7.39675 20.1856 7.05462 20.1384 5.98106C20.0873 4.91144 19.9182 4.18 19.6704 3.53901C19.4148 2.87836 19.0688 2.31602 18.5104 1.75367C17.952 1.19527 17.3896 0.849209 16.725 0.593599C16.084 0.345855 15.3526 0.176759 14.283 0.125637C13.2094 0.0784478 12.8673 0.0666504 10.1342 0.0666504ZM10.1342 1.87951C12.8201 1.87951 13.1426 1.89131 14.2043 1.9385C15.1874 1.98569 15.7183 2.14692 16.0722 2.28849C16.5441 2.46938 16.8784 2.6896 17.2323 3.03959C17.5823 3.39351 17.8025 3.72777 17.9834 4.19966C18.121 4.55358 18.2862 5.08446 18.3295 6.06758C18.3767 7.12934 18.3885 7.44787 18.3885 10.1377C18.3885 12.8275 18.3767 13.146 18.3255 14.2078C18.2744 15.1909 18.1092 15.7218 17.9716 16.0757C17.7829 16.5476 17.5705 16.8818 17.2166 17.2358C16.8666 17.5857 16.5245 17.806 16.0604 17.9869C15.7065 18.1245 15.1678 18.2897 14.1847 18.3329C13.115 18.3801 12.8004 18.3919 10.1067 18.3919C7.41297 18.3919 7.09837 18.3801 6.02875 18.329C5.04563 18.2779 4.50689 18.1127 4.15296 17.9751C3.67714 17.7863 3.34681 17.5739 2.99682 17.22C2.6429 16.87 2.41875 16.5279 2.24179 16.0639C2.10415 15.71 1.93899 15.1712 1.88787 14.1881C1.84854 13.1303 1.83675 12.8039 1.83675 10.1259C1.83675 7.44394 1.84854 7.11754 1.88787 6.04792C1.93899 5.0648 2.10022 4.52606 2.24179 4.17213C2.41875 3.69237 2.6429 3.36598 2.99682 3.01206C3.34681 2.66207 3.67714 2.43399 4.15296 2.25703C4.50689 2.11939 5.03383 1.95423 6.01695 1.90311C7.08658 1.86378 7.40117 1.85199 10.0949 1.85199L10.1342 1.87951ZM10.1342 4.96256C7.27927 4.96256 4.96305 7.27877 4.96305 10.1337C4.96305 12.9887 7.27927 15.3049 10.1342 15.3049C12.9892 15.3049 15.3054 12.9887 15.3054 10.1337C15.3054 7.27877 12.9892 4.96256 10.1342 4.96256ZM10.1342 13.4881C8.28204 13.4881 6.77984 11.9859 6.77984 10.1337C6.77984 8.28155 8.28204 6.77935 10.1342 6.77935C11.9864 6.77935 13.4886 8.28155 13.4886 10.1337C13.4886 11.9859 11.9864 13.4881 10.1342 13.4881ZM16.7172 4.762C16.7172 5.43052 16.1745 5.96927 15.5099 5.96927C14.8414 5.96927 14.3026 5.42659 14.3026 4.762C14.3026 4.09742 14.8453 3.55474 15.5099 3.55474C16.1745 3.55081 16.7172 4.09348 16.7172 4.762Z" fill="#353A3B"/></svg>
//                   </a></li>
//                   <li><a href="#" title="Twitter">
//                     <svg xmlns="http://www.w3.org/2000/svg" width="21" height="17" viewBox="0 0 21 17" fill="none"><path d="M20.5946 1.95191C19.8553 2.2783 19.0648 2.49852 18.2312 2.60077C19.0806 2.08955 19.7334 1.28339 20.0401 0.323874C19.2457 0.787904 18.3609 1.1261 17.425 1.31485C16.6739 0.512632 15.6082 0.00927734 14.4206 0.00927734C12.1477 0.00927734 10.3033 1.8536 10.3033 4.12263C10.3033 4.44902 10.3427 4.76362 10.4095 5.06248C6.98828 4.90125 3.95242 3.25749 1.92327 0.772174C1.56542 1.37777 1.36487 2.07775 1.36487 2.84458C1.36487 4.27599 2.09237 5.53438 3.19739 6.27368C2.52101 6.25009 1.88788 6.06526 1.33341 5.75853V5.80965C1.33341 7.80734 2.74909 9.47077 4.63667 9.84828C4.29061 9.94266 3.92489 9.98985 3.55131 9.98985C3.28784 9.98985 3.03616 9.96626 2.78448 9.91907C3.31143 11.555 4.82936 12.7465 6.63829 12.778C5.2344 13.883 3.44907 14.5397 1.53396 14.5397C1.20757 14.5397 0.881173 14.52 0.554779 14.4846C2.3873 15.6526 4.54622 16.3329 6.87817 16.3329C14.4481 16.3329 18.589 10.0606 18.589 4.62991C18.589 4.45688 18.589 4.27992 18.5772 4.10296C19.3794 3.52489 20.0834 2.79739 20.6339 1.97157L20.5946 1.95191Z" fill="#353A3B"/></svg>
//                   </a></li>
//                 </ul>
//               </div> */}

//               {/* openTermsModal */}
//               <div className="footer-links">
//                 <ul>
//                   <li>
//                     <a
//                       href="#"
//                       onClick={(e) => {
//                         e.preventDefault();
//                         window.openPrivacyModal && window.openPrivacyModal();
//                       }}
//                     >
//                       Privacy
//                     </a>
//                   </li>
//                   {/* <li><a href="#">Equality Policy</a></li> */}
//                   <li>
//                     <a
//                       href="#"
//                       onClick={(e) => {
//                         e.preventDefault();
//                         window.openTermsModal && window.openTermsModal();
//                       }}
//                     >
//                       Terms & Conditions
//                     </a>
//                   </li>
//                 </ul>
//               </div>
//               <div className="footer-copyright">
//                 <p>2025 © LittleOne Infinity Pvt. Ltd.</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

// function ContactForm() {
//   const [formData, setFormData] = useState({
//     fullName: "",
//     email: "",
//     subject: "",
//     body: "",
//   });

//   const { sendRequest } = useHttp();
//   const [isLoading, setIsLoading] = useState(false);
//   const [emailResponse, setEmailResponse] = useState({
//     message: "",
//     success: false,
//   });
//   const [ticketId, setTicketId] = useState(null);
//   const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

//   const [selectedCountry, setSelectedCountry] = useState("india");

//   // Country data from the screenshot
//   const countryData = {
//     india: {
//       flag: "/assets/images/Flag_of_India.svg.webp",
//       code: "IND",
//       name: "India",
//       location: "Ahmedabad, Gujarat, India",
//       fullAddress:
//         "LittleOne Infinity Pvt. Ltd, 524-525, INDRAPRASTH BUSINESS PARK, Makarba, Ahmedabad, Gujarat 380051",
//       email: "info.india@little.global",
//       phone: "+91 70164 43239",
//       social: [
//         { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
//         { facebook: "https://www.facebook.com/LittleAppKE/" },
//         { twitter: "https://www.instagram.com/littlerideke/" },
//         { instagram: "https://www.instagram.com/littlerideke/" },
//       ],
//     },
//     kenya: {
//       flag: "/assets/images/Flag_of_Kenya.webp",
//       code: "KE",
//       name: "Kenya",
//       location: "Nairobi, Kenya",
//       fullAddress: "Musa Gitau Rd, Nairobi, Kenya",
//       email: "support@little.africa",
//       phone: "+256200914243",
//       // social: ["linkedin", "facebook", "twitter", "instagram"],
//       social: [
//         { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
//         { facebook: "https://www.facebook.com/LittleAppKE/" },
//         { twitter: "https://www.instagram.com/littlerideke/" },
//         { instagram: "https://www.instagram.com/littlerideke/" },
//       ],
//     },
//     uganda: {
//       flag: "/assets/images/Flag_of_Uganda.svg.png",
//       code: "UG",
//       name: "Uganda",
//       location: "Kampala, Uganda",
//       fullAddress: "Kampala, Uganda",
//       email: "salesug@little.africa",
//       phone: "+256200914243",
//       // social: ["linkedin", "facebook", "instagram"],
//       social: [
//         { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
//         { facebook: "https://www.facebook.com/LittleAppKE/" },
//         { instagram: "https://www.instagram.com/littlerideke/" },
//       ],
//     },
//     tanzania: {
//       flag: "/assets/images/Flag_of_Tanzania.jpg",
//       code: "TZ",
//       name: "Tanzania",
//       location: "Dar es Salaam, Tanzania",
//       fullAddress: "Dar es Salaam, Tanzania",
//       email: "customerservice@little.africa",
//       phone: "+255 762 874 302",
//       // social: ["linkedin", "facebook", "instagram"],
//       social: [
//         { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
//         { facebook: "https://www.facebook.com/LittleAppKE/" },
//         { instagram: "https://www.instagram.com/littlerideke/" },
//       ],
//     },
//     ethiopia: {
//       flag: "/assets/images/Flag_of_Ethiopia.svg.png",
//       code: "ET",
//       name: "Ethiopia",
//       location: "Addis Ababa, Ethiopia",
//       fullAddress: "Addis Ababa, Ethiopia",
//       email: "info.ethiopia@little.africa",
//       phone: "+25115571407",
//       // social: ["linkedin", "facebook", "twitter", "instagram"],
//       social: [
//         { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
//         { facebook: "https://www.facebook.com/LittleAppKE/" },
//         { twitter: "https://www.instagram.com/littlerideke/" },
//         { instagram: "https://www.instagram.com/littlerideke/" },
//       ],
//     },
//     somalia: {
//       flag: "/assets/images/Flag_of_Somalia.svg.png",
//       code: "SO",
//       name: "Somalia",
//       location: "Mogadishu, Somalia",
//       fullAddress: "Mogadishu, Somalia",
//       email: "littlesom@little.africa",
//       phone: "3838",
//       // social: ["linkedin", "facebook", "twitter", "instagram"],
//       social: [
//         { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
//         { facebook: "https://www.facebook.com/LittleAppKE/" },
//         { twitter: "https://www.instagram.com/littlerideke/" },
//         { instagram: "https://www.instagram.com/littlerideke/" },
//       ],
//     },
//     senegal: {
//       flag: "/assets/images/Flag_of_Senegal.svg.png",
//       code: "SN",
//       name: "Senegal",
//       location: "Dakar, Senegal",
//       fullAddress: "Dakar, Senegal",
//       email: "contact@wigo.africa",
//       phone: "+221 77 744 96 96",
//       // social: ["linkedin", "twitter"],
//       social: [
//         { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
//         { twitter: "https://www.instagram.com/littlerideke/" },
//       ],
//     },
//     ghana: {
//       flag: "/assets/images/Flag_of_Ghana.webp",
//       code: "GH",
//       name: "Ghana",
//       location: "Accra, Ghana",
//       fullAddress: "Accra, Ghana",
//       email: "customer-support@little.bz",
//       phone: "0507795596",
//       // social: ["linkedin", "facebook", "twitter", "instagram"],
//       social: [
//         { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
//         { facebook: "https://www.facebook.com/LittleAppKE/" },
//         { twitter: "https://www.instagram.com/littlerideke/" },
//         { instagram: "https://www.instagram.com/littlerideke/" },
//       ],
//     },
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prev) => ({
//       ...prev,

//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     console.log("inside the handleSubmit", e);
//     setIsLoading(true);

//     setEmailResponse({ message: "", success: false });

//     // Define the callback function before using it
//     const authenticateUser = (data) => {
//       if (data.status === 200 || data.status === 201) {
//         setFormData({ fullName: "", email: "", subject: "", body: "" });
//         setTicketId(data.id || data.ticketId);
//         setOpenSuccessDialog(true);
//         setEmailResponse({
//           message: data?.message || "Your message has been sent successfully!",
//           success: true,
//         });
//       } else {
//         setEmailResponse({
//           message: data?.message || "Error occurred. Please try again.",
//           success: false,
//         });
//       }
//       setIsLoading(false);
//     };

//     try {
//       // Try direct API first
//       console.log("Sending request to /customer-support with data:", {
//         from: formData.email,
//         fullName: formData.fullName,
//         subject: formData.subject,
//         message: formData.body,
//       });

//       sendRequest(
//         {
//           url: "/customer-support",
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: {
//             from: formData.email,
//             fullName: formData.fullName,
//             subject: formData.subject,
//             message: formData.body,
//           },
//         },
//         authenticateUser
//       );

//       console.log("sendRequest called successfully");
//     } catch (error) {
//       console.error("API Error:", error);
//       setEmailResponse({
//         message: "Network error. Please try again.",
//         success: false,
//       });
//       setIsLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     setFormData({ fullName: "", email: "", subject: "", body: "" });
//     setEmailResponse({ message: "", success: false });
//   };

//   return (
//     <section
//       className="contact-form-section padding-bottom"
//       id="contactFormSection"
//     >
//       <div className="container">
//         <div className="section-title">
//           <h2>Contact Us</h2>
//         </div>
//         <div className="contact-container">
//           <div className="row align-items-stretch">
//             {/* Left Side - Company Details (40%) */}
//             <div className="col-lg-5 col-md-5 col-sm-12 col-12">
//               <div className="contact-info-wrapper">
//                 <div className="company-logo">
//                   <img
//                     src="/assets/images/Logo.png"
//                     alt="Little Logo"
//                     className="img-fluid"
//                   />
//                 </div>
//                 <div className="company-info">
//                   {/* <h3>Get in Touch</h3>
//                   <p>Ready to transform your mobility solutions? Contact us for a personalized demo and discover how Little can streamline your transportation needs.</p> */}
//                   <p>
//                     Little is a pan-African "everyday everything" app and one of
//                     the African largest ride-hailing service companies, serving
//                     cities across{" "}
//                     <span className="country-text india">India</span>,{" "}
//                     <span className="country-text kenya">Kenya</span>,{" "}
//                     <span className="country-text uganda">Uganda</span>,{" "}
//                     <span className="country-text tanzania">Tanzania</span>,{" "}
//                     <span className="country-text ethiopia">Ethiopia</span>,{" "}
//                     <span className="country-text somalia">Somalia</span>,{" "}
//                     <span className="country-text senegal">Senegal</span>, and{" "}
//                     <span className="country-text ghana">Ghana</span>. The
//                     Little app offers mobility, delivery and payment solutions
//                     by connecting customers to drivers and delivery agents,
//                     enabling convenience and transparency for hundreds of
//                     thousands of customers.
//                   </p>
//                   {/* Country Flags Section */}
//                   <div className="country-flags-section">
//                     <div className="flags-container">
//                       {Object.entries(countryData).map(([key, country]) => (
//                         <div
//                           key={key}
//                           className={`country-flag ${
//                             selectedCountry === key ? "active" : ""
//                           }`}
//                           onMouseEnter={() => setSelectedCountry(key)}
//                           title={`${country.name} (${country.code})`}
//                         >
//                           <img
//                             src={country.flag}
//                             alt={`${country.name} flag`}
//                             className="flag-image"
//                           />
//                         </div>
//                       ))}
//                     </div>
//                   </div>

//                   <div className="contact-details">
//                     <div
//                       className="contact-item"
//                       onClick={() =>
//                         window.open(
//                           `https://maps.google.com/?q=${encodeURIComponent(
//                             countryData[selectedCountry].fullAddress
//                           )}`,
//                           "_blank"
//                         )
//                       }
//                     >
//                       <div
//                         className="contact-icon"
//                         onClick={() =>
//                           window.open(
//                             `tel:${countryData[selectedCountry].phone}`,
//                             "_blank"
//                           )
//                         }
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="20"
//                           height="20"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                         >
//                           <path
//                             d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
//                             fill="white"
//                           />
//                         </svg>
//                       </div>
//                       <div className="contact-text">
//                         <span>{countryData[selectedCountry].location}</span>
//                       </div>
//                     </div>

//                     <div
//                       className="contact-item"
//                       onClick={() =>
//                         window.open(
//                           `mailto:${countryData[selectedCountry].email}`,
//                           "_blank"
//                         )
//                       }
//                     >
//                       <div className="contact-icon">
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="20"
//                           height="20"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                         >
//                           <path
//                             d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
//                             fill="white"
//                           />
//                         </svg>
//                       </div>
//                       <div className="contact-text">
//                         <span>{countryData[selectedCountry].email}</span>
//                       </div>
//                     </div>

//                     {countryData[selectedCountry].phone && (
//                       <div
//                         className="contact-item"
//                         onClick={() => {
//                           // Create a temporary link element for better protocol handling
//                           const link = document.createElement("a");
//                           link.href = `tel:${countryData[selectedCountry].phone}`;
//                           link.click();
//                         }}
//                       >
//                         <div className="contact-icon">
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             width="20"
//                             height="20"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                           >
//                             <path
//                               d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
//                               fill="white"
//                             />
//                           </svg>
//                         </div>
//                         <div className="contact-text">
//                           <span>{countryData[selectedCountry].phone}</span>
//                         </div>
//                       </div>
//                     )}
//                   </div>

//                   {/* Social Media Icons */}
//                   <div className="social-media-section">
//                     <div className="social-icons">
//                       <a
//                         href="https://www.instagram.com/littlerideke/"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="social-icon instagram"
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="20"
//                           height="20"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                         >
//                           <path
//                             d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
//                             fill="currentColor"
//                           />
//                         </svg>
//                       </a>

//                       <a
//                         href="https://www.facebook.com/LittleAppKE/"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="social-icon facebook"
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="20"
//                           height="20"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                         >
//                           <path
//                             d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
//                             fill="currentColor"
//                           />
//                         </svg>
//                       </a>

//                       <a
//                         href="https://x.com/littleappkenya/"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="social-icon twitter"
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="20"
//                           height="20"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                         >
//                           <path
//                             d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
//                             fill="currentColor"
//                           />
//                         </svg>
//                       </a>

//                       <a
//                         href="https://www.linkedin.com/company/littlesuperapp/"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="social-icon linkedin"
//                       >
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="20"
//                           height="20"
//                           viewBox="0 0 24 24"
//                           fill="none"
//                         >
//                           <path
//                             d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
//                             fill="currentColor"
//                           />
//                         </svg>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Right Side - Contact Form (60%) */}
//             <div className="col-lg-7 col-md-7 col-sm-12 col-12">
//               <div className="contact-form-wrapper">
//                 <div className="form-header">
//                   {/* <h2>Send us a Message</h2>
//                   <p>Fill out the form below and we'll get back to you as soon as possible.</p> */}
//                   <h3>Get in Touch</h3>
//                   <p>
//                     Ready to transform your mobility solutions? Contact us for a
//                     personalized demo and discover how Little can streamline
//                     your transportation needs.
//                   </p>
//                 </div>

//                 <form onSubmit={handleSubmit} className="contact-form">
//                   {/* Response Message */}
//                   {emailResponse.message && (
//                     <div
//                       className={`form-response ${
//                         emailResponse.success ? "success" : "error"
//                       }`}
//                     >
//                       {emailResponse.message}
//                       {ticketId && <p>Ticket ID: {ticketId}</p>}
//                     </div>
//                   )}

//                   <div className="form-fields">
//                     <div className="form-row">
//                       <div className="form-group">
//                         <label htmlFor="fullName">Full Name *</label>
//                         <input
//                           type="text"
//                           id="fullName"
//                           name="fullName"
//                           value={formData.fullName}
//                           onChange={handleInputChange}
//                           required
//                           disabled={isLoading}
//                           placeholder="Enter your full name"
//                         />
//                       </div>

//                       <div className="form-group">
//                         <label htmlFor="email">Email *</label>
//                         <input
//                           type="email"
//                           id="email"
//                           name="email"
//                           value={formData.email}
//                           onChange={handleInputChange}
//                           required
//                           disabled={isLoading}
//                           placeholder="your email address"
//                         />
//                       </div>
//                     </div>

//                     <div className="form-group">
//                       <label htmlFor="subject">Subject *</label>
//                       <input
//                         type="text"
//                         id="subject"
//                         name="subject"
//                         value={formData.subject}
//                         onChange={handleInputChange}
//                         required
//                         disabled={isLoading}
//                         placeholder="Enter the subject of your inquiry"
//                       />
//                     </div>

//                     <div className="form-group">
//                       <label htmlFor="body">Message *</label>
//                       <textarea
//                         id="body"
//                         name="body"
//                         value={formData.body}
//                         onChange={handleInputChange}
//                         required
//                         disabled={isLoading}
//                         rows="4"
//                         placeholder="Enter your message here..."
//                       ></textarea>
//                     </div>
//                   </div>

//                   <div className="form-buttons">
//                     {/* <button
//                     type="button" 
//                     onClick={handleCancel} 
//                     className="cancel-btn"
//                     disabled={isLoading}
//                   >
//                     Cancel

//                     </button> */}
//                     <button
//                       type="submit"
//                       className="submit-btn"
//                       disabled={isLoading}
//                     >
//                       {isLoading ? "Sending..." : "Send Message"}
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Success Popup Modal */}
//       {openSuccessDialog && (
//         <div
//           className="modal-overlay"
//           onClick={() => setOpenSuccessDialog(false)}
//         >
//           <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Message Sent Successfully!</h3>
//               <button
//                 className="modal-close"
//                 onClick={() => setOpenSuccessDialog(false)}
//               >
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <p>Thank you for contacting us. We will get back to you soon.</p>
//               {ticketId && (
//                 <div className="ticket-info">
//                   <strong>Your Ticket ID: {ticketId}</strong>
//                   <p>Please keep this ID for your reference.</p>
//                 </div>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button
//                 className="btn-primary"
//                 onClick={() => setOpenSuccessDialog(false)}
//               >
//                 OK
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// }

// function FloatingChatWidget() {
//   const scrollToContactForm = () => {
//     const contactSection = document.getElementById("contactFormSection");
//     if (contactSection) {
//       contactSection.scrollIntoView({ behavior: "smooth" });
//     }
//   };

//   return (
//     <div className="floating-chat-widget" onClick={scrollToContactForm}>
//       <div className="chat-icon">
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           width="24"
//           height="24"
//           viewBox="0 0 24 24"
//           fill="none"
//         >
//           <path
//             d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
//             fill="white"
//           />
//           <path d="M7 9H17V11H7V9ZM7 12H15V14H7V12Z" fill="white" />
//         </svg>
//       </div>
//       <div className="chat-text">
//         <span>Contact Us</span>
//       </div>
//     </div>
//   );
// }
import Home from "./pages/Home.jsx";
import Schools from "./pages/Schools.jsx";
import Corporate from "./pages/Corporate.jsx";
import ClientSection from "./components/ClientSection.jsx";
import TestimonialSection from "./components/TestimonialSection.jsx";
import PrivacyPolicyModal from "./components/PrivacyPolicyModal.jsx";
import TermsConditionModal from "./components/TermsConditionModal.jsx";
import OurAppsSection from "./pages/OurAppSection.jsx";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

// Import CSS files
import "./assets/css/bootstrap.min.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import useHttp from "../Hooks/use-http.js";

export default function LandingPage() {
  useEffect(() => {
    // Add class to body when landing page is mounted
    document.body.classList.add("landing-page-active");

    // Cleanup: remove class when component unmounts
    return () => {
      document.body.classList.remove("landing-page-active");
    };
  }, []);

  return (
    <div className="landingPage">
      <Header />
      {/* Single-page content: render sections sequentially */}
      <Home />
      <Corporate />
      <Schools />
      <ClientSection />
      <OurAppsSection />
      {/* <TestimonialSection /> */}
      <ContactForm />
      <Footer />
      <FloatingChatWidget />
      <PrivacyPolicyModal />
      <TermsConditionModal />
    </div>
  );
}

function Header() {
  const history = useHistory();

  // Helper function to check if token is valid
  const isTokenValid = () => {
    const token = Cookies.get("token");
    if (!token) {
      return false;
    }
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      return decoded.exp >= currentTime;
    } catch (error) {
      console.error("Invalid token", error);
      return false;
    }
  };

  // Handle Corporate Login click
  const handleCorporateLoginClick = (e) => {
    e.preventDefault();
    
    // Check if token exists and is valid
    if (isTokenValid()) {
      // Token is valid, redirect to dashboard
      // routes.js will handle redirecting to firstUrl if available after login check
      history.push("/dashboard");
    } else {
      // No token or token expired, go to login page
      // Set flag to indicate user came from landing page
      sessionStorage.setItem("cameFromLanding", "true");
      history.push("/login");
    }
  };

  return (
    <header className="page-header">
      <div className="container">
        <div className="header-row align-items-center">
          <div className="page-header-top">
            <div className="page-header-logo">
              <a
                href="#BannerSection"
                onClick={(e) => {
                  e.preventDefault();
                  document.body.classList.remove("show-home-only");
                  document.body.classList.add("show-all-sections");
                  // Scroll to top of page
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  // Reset banner carousel to first slide
                  const bannerCarousel =
                    document.getElementById("bannerCarousel");
                  if (bannerCarousel) {
                    // Reset to first slide
                    bannerCarousel.style.transform = "translateX(0%)";
                    // Trigger a custom event to reset the carousel state
                    const resetEvent = new CustomEvent("resetBannerCarousel");
                    bannerCarousel.dispatchEvent(resetEvent);
                  }
                }}
              >
                <img
                  src="/assets/images/Logo.png"
                  className="img-fluid main-logo"
                  alt=""
                />
              </a>
            </div>

            <div
              className="page-header-toggle"
              onClick={() => {
                document
                  .getElementById("navigation")
                  ?.classList.toggle("navigation-visible");
              }}
            >
              ☰
            </div>
          </div>
          <nav className="page-header-bottom">
            <div className="header-right">
              <ul id="navigation" className="navigation">
                <li className="navigation-item">
                  <a
                    href="#BannerSection"
                    onClick={(e) => {
                      e.preventDefault();
                      document.body.classList.remove("show-home-only");
                      document.body.classList.add("show-all-sections");
                      // Scroll to top of page
                      window.scrollTo({ top: 0, behavior: "smooth" });
                      // Reset banner carousel to first slide
                      const bannerCarousel =
                        document.getElementById("bannerCarousel");
                      if (bannerCarousel) {
                        // Reset to first slide
                        bannerCarousel.style.transform = "translateX(0%)";
                        // Trigger a custom event to reset the carousel state
                        const resetEvent = new CustomEvent(
                          "resetBannerCarousel"
                        );
                        bannerCarousel.dispatchEvent(resetEvent);
                      }
                    }}
                  >
                    Home
                  </a>
                </li>
                <li className="navigation-item">
                  <a
                    href="#AboutSection"
                    onClick={() => {
                      document.body.classList.remove("show-home-only");
                      document.body.classList.add("show-all-sections");
                    }}
                  >
                    About Us
                  </a>
                </li>
                <li className="navigation-item">
                  <a
                    href="#corporateSection"
                    onClick={(e) => {
                      e.preventDefault();
                      document.body.classList.remove("show-home-only");
                      document.body.classList.add("show-all-sections");
                      // Scroll to Corporate section
                      const corporateSection =
                        document.getElementById("corporateSection");
                      if (corporateSection) {
                        corporateSection.scrollIntoView({ behavior: "smooth" });
                      }
                    }}
                  >
                    Corporate Commuter
                  </a>
                </li>
                <li className="navigation-item">
                  <a
                    href="#busbuddySection"
                    onClick={() => {
                      document.body.classList.remove("show-home-only");
                      document.body.classList.add("show-all-sections");
                    }}
                  >
                    BusBuddy
                  </a>
                </li>
                <li className="navigation-item">
                  <a
                    href="#clientSection"
                    onClick={() => {
                      document.body.classList.remove("show-home-only");
                      document.body.classList.add("show-all-sections");
                    }}
                  >
                    Clients
                  </a>
                </li>
                <li className="navigation-item">
                  <a
                    href="#ourAppsSection"
                    onClick={(e) => {
                      e.preventDefault();
                      document.body.classList.remove("show-home-only");
                      document.body.classList.add("show-all-sections");
                      const ourAppsSection = document.getElementById("ourAppsSection");
                      if (ourAppsSection) {
                        ourAppsSection.scrollIntoView({ behavior: "smooth" });
                      }
                    }}
                  >
                    Our Apps
                  </a>
                </li>
                {/* Testimonial */}
                {/* <li className="navigation-item">
                  <a
                    href="#testimonialSection"
                    onClick={() => {
                      document.body.classList.remove("show-home-only");
                      document.body.classList.add("show-all-sections");
                    }}
                  >
                    Testimonials
                  </a>
                </li> */}

                <li className="navigation-item">
                  <a
                    href="#contactFormSection"
                    onClick={() => {
                      document.body.classList.remove("show-home-only");
                      document.body.classList.add("show-all-sections");
                    }}
                  >
                    Contact Us
                  </a>
                </li>
                {/* <li className="navigation-item"><a href="#registerSection">Register</a></li> */}

                <a
                  href="/login"
                  className="header-button"
                  onClick={handleCorporateLoginClick}
                >
                  Corporate Login
                </a>
              </ul>
              <div className="header-btn"></div>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-3 col-md-4 col-sm-12">
            <div className="footer-logo">
              <img
                src="/assets/images/footer-logo.png"
                className="img-fluid"
                alt="Little Logo"
              />
            </div>
          </div>
          <div className="col-lg-9 col-md-8 col-sm-12">
            <div className="footer-content">
              {/* <div className="footer-social">
                <ul>
                  <li><a href="#" title="Facebook">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="21" viewBox="0 0 12 21" fill="none"><path d="M7.69928 20.2008V11.0303H10.7902L11.2542 7.43998H7.69928V5.15522C7.69928 4.11705 7.98635 3.41314 9.47282 3.41314H11.3565V0.212125C11.0301 0.168868 9.90539 0.0705566 8.59588 0.0705566C5.86283 0.0705566 3.99098 1.73792 3.99098 4.8013V7.44391H0.911865V11.0342H3.99098V20.2008H7.69928Z" fill="#353A3B"/></svg>
                  </a></li>
                  <li><a href="#" title="Instagram">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M10.1342 0.0666504C7.40117 0.0666504 7.05905 0.0784478 5.98549 0.125637C4.91193 0.176759 4.18442 0.345855 3.54343 0.593599C2.88278 0.849209 2.32044 1.19527 1.7581 1.75367C1.19576 2.31208 0.853634 2.87442 0.598024 3.53901C0.35028 4.18 0.181184 4.91144 0.130062 5.98106C0.0789404 7.05462 0.0710754 7.39675 0.0710754 10.1298C0.0710754 12.8629 0.0828728 13.205 0.130062 14.2785C0.181184 15.3482 0.35028 16.0796 0.598024 16.7206C0.853634 17.3813 1.19969 17.9436 1.7581 18.5059C2.31651 19.0643 2.87885 19.4104 3.54343 19.666C4.18442 19.9138 4.91586 20.0829 5.98549 20.134C7.05905 20.1851 7.40117 20.193 10.1342 20.193C12.8673 20.193 13.2094 20.1812 14.283 20.134C15.3526 20.0829 16.084 19.9138 16.725 19.666C17.3857 19.4104 17.948 19.0643 18.5104 18.5059C19.0688 17.9475 19.4148 17.3852 19.6704 16.7206C19.9182 16.0796 20.0873 15.3482 20.1384 14.2785C20.1895 13.205 20.1974 12.8629 20.1974 10.1298C20.1974 7.39675 20.1856 7.05462 20.1384 5.98106C20.0873 4.91144 19.9182 4.18 19.6704 3.53901C19.4148 2.87836 19.0688 2.31602 18.5104 1.75367C17.952 1.19527 17.3896 0.849209 16.725 0.593599C16.084 0.345855 15.3526 0.176759 14.283 0.125637C13.2094 0.0784478 12.8673 0.0666504 10.1342 0.0666504ZM10.1342 1.87951C12.8201 1.87951 13.1426 1.89131 14.2043 1.9385C15.1874 1.98569 15.7183 2.14692 16.0722 2.28849C16.5441 2.46938 16.8784 2.6896 17.2323 3.03959C17.5823 3.39351 17.8025 3.72777 17.9834 4.19966C18.121 4.55358 18.2862 5.08446 18.3295 6.06758C18.3767 7.12934 18.3885 7.44787 18.3885 10.1377C18.3885 12.8275 18.3767 13.146 18.3255 14.2078C18.2744 15.1909 18.1092 15.7218 17.9716 16.0757C17.7829 16.5476 17.5705 16.8818 17.2166 17.2358C16.8666 17.5857 16.5245 17.806 16.0604 17.9869C15.7065 18.1245 15.1678 18.2897 14.1847 18.3329C13.115 18.3801 12.8004 18.3919 10.1067 18.3919C7.41297 18.3919 7.09837 18.3801 6.02875 18.329C5.04563 18.2779 4.50689 18.1127 4.15296 17.9751C3.67714 17.7863 3.34681 17.5739 2.99682 17.22C2.6429 16.87 2.41875 16.5279 2.24179 16.0639C2.10415 15.71 1.93899 15.1712 1.88787 14.1881C1.84854 13.1303 1.83675 12.8039 1.83675 10.1259C1.83675 7.44394 1.84854 7.11754 1.88787 6.04792C1.93899 5.0648 2.10022 4.52606 2.24179 4.17213C2.41875 3.69237 2.6429 3.36598 2.99682 3.01206C3.34681 2.66207 3.67714 2.43399 4.15296 2.25703C4.50689 2.11939 5.03383 1.95423 6.01695 1.90311C7.08658 1.86378 7.40117 1.85199 10.0949 1.85199L10.1342 1.87951ZM10.1342 4.96256C7.27927 4.96256 4.96305 7.27877 4.96305 10.1337C4.96305 12.9887 7.27927 15.3049 10.1342 15.3049C12.9892 15.3049 15.3054 12.9887 15.3054 10.1337C15.3054 7.27877 12.9892 4.96256 10.1342 4.96256ZM10.1342 13.4881C8.28204 13.4881 6.77984 11.9859 6.77984 10.1337C6.77984 8.28155 8.28204 6.77935 10.1342 6.77935C11.9864 6.77935 13.4886 8.28155 13.4886 10.1337C13.4886 11.9859 11.9864 13.4881 10.1342 13.4881ZM16.7172 4.762C16.7172 5.43052 16.1745 5.96927 15.5099 5.96927C14.8414 5.96927 14.3026 5.42659 14.3026 4.762C14.3026 4.09742 14.8453 3.55474 15.5099 3.55474C16.1745 3.55081 16.7172 4.09348 16.7172 4.762Z" fill="#353A3B"/></svg>
                  </a></li>
                  <li><a href="#" title="Twitter">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="17" viewBox="0 0 21 17" fill="none"><path d="M20.5946 1.95191C19.8553 2.2783 19.0648 2.49852 18.2312 2.60077C19.0806 2.08955 19.7334 1.28339 20.0401 0.323874C19.2457 0.787904 18.3609 1.1261 17.425 1.31485C16.6739 0.512632 15.6082 0.00927734 14.4206 0.00927734C12.1477 0.00927734 10.3033 1.8536 10.3033 4.12263C10.3033 4.44902 10.3427 4.76362 10.4095 5.06248C6.98828 4.90125 3.95242 3.25749 1.92327 0.772174C1.56542 1.37777 1.36487 2.07775 1.36487 2.84458C1.36487 4.27599 2.09237 5.53438 3.19739 6.27368C2.52101 6.25009 1.88788 6.06526 1.33341 5.75853V5.80965C1.33341 7.80734 2.74909 9.47077 4.63667 9.84828C4.29061 9.94266 3.92489 9.98985 3.55131 9.98985C3.28784 9.98985 3.03616 9.96626 2.78448 9.91907C3.31143 11.555 4.82936 12.7465 6.63829 12.778C5.2344 13.883 3.44907 14.5397 1.53396 14.5397C1.20757 14.5397 0.881173 14.52 0.554779 14.4846C2.3873 15.6526 4.54622 16.3329 6.87817 16.3329C14.4481 16.3329 18.589 10.0606 18.589 4.62991C18.589 4.45688 18.589 4.27992 18.5772 4.10296C19.3794 3.52489 20.0834 2.79739 20.6339 1.97157L20.5946 1.95191Z" fill="#353A3B"/></svg>
                  </a></li>
                </ul>
              </div> */}

              {/* openTermsModal */}
              <div className="footer-links">
                <ul>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        window.openPrivacyModal && window.openPrivacyModal();
                      }}
                    >
                      Privacy
                    </a>
                  </li>
                  {/* <li><a href="#">Equality Policy</a></li> */}
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        window.openTermsModal && window.openTermsModal();
                      }}
                    >
                      Terms & Conditions
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-copyright">
                <p>2025 © LittleOne Infinity Pvt. Ltd.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

function ContactForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    body: "",
  });

  const { sendRequest } = useHttp();
  const [isLoading, setIsLoading] = useState(false);
  const [emailResponse, setEmailResponse] = useState({
    message: "",
    success: false,
  });
  const [ticketId, setTicketId] = useState(null);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  const [selectedCountry, setSelectedCountry] = useState("india");

  // Country data from the screenshot
  const countryData = {
    india: {
      flag: "/assets/images/Flag_of_India.svg.webp",
      code: "IND",
      name: "India",
      location: "Ahmedabad, Gujarat, India",
      fullAddress:
        "LittleOne Infinity Pvt. Ltd, 524-525, INDRAPRASTH BUSINESS PARK, Makarba, Ahmedabad, Gujarat 380051",
      email: "info.india@little.global",
      phone: "+91 70164 43239",
      social: [
        { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
        { facebook: "https://www.facebook.com/LittleAppKE/" },
        { twitter: "https://www.instagram.com/littlerideke/" },
        { instagram: "https://www.instagram.com/littlerideke/" },
      ],
    },
    kenya: {
      flag: "/assets/images/Flag_of_Kenya.webp",
      code: "KE",
      name: "Kenya",
      location: "Nairobi, Kenya",
      fullAddress: "Musa Gitau Rd, Nairobi, Kenya",
      email: "support@little.africa",
      phone: "+256200914243",
      // social: ["linkedin", "facebook", "twitter", "instagram"],
      social: [
        { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
        { facebook: "https://www.facebook.com/LittleAppKE/" },
        { twitter: "https://www.instagram.com/littlerideke/" },
        { instagram: "https://www.instagram.com/littlerideke/" },
      ],
    },
    uganda: {
      flag: "/assets/images/Flag_of_Uganda.svg.png",
      code: "UG",
      name: "Uganda",
      location: "Kampala, Uganda",
      fullAddress: "Kampala, Uganda",
      email: "salesug@little.africa",
      phone: "+256200914243",
      // social: ["linkedin", "facebook", "instagram"],
      social: [
        { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
        { facebook: "https://www.facebook.com/LittleAppKE/" },
        { instagram: "https://www.instagram.com/littlerideke/" },
      ],
    },
    tanzania: {
      flag: "/assets/images/Flag_of_Tanzania.jpg",
      code: "TZ",
      name: "Tanzania",
      location: "Dar es Salaam, Tanzania",
      fullAddress: "Dar es Salaam, Tanzania",
      email: "customerservice@little.africa",
      phone: "+255 762 874 302",
      // social: ["linkedin", "facebook", "instagram"],
      social: [
        { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
        { facebook: "https://www.facebook.com/LittleAppKE/" },
        { instagram: "https://www.instagram.com/littlerideke/" },
      ],
    },
    ethiopia: {
      flag: "/assets/images/Flag_of_Ethiopia.svg.png",
      code: "ET",
      name: "Ethiopia",
      location: "Addis Ababa, Ethiopia",
      fullAddress: "Addis Ababa, Ethiopia",
      email: "info.ethiopia@little.africa",
      phone: "+25115571407",
      // social: ["linkedin", "facebook", "twitter", "instagram"],
      social: [
        { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
        { facebook: "https://www.facebook.com/LittleAppKE/" },
        { twitter: "https://www.instagram.com/littlerideke/" },
        { instagram: "https://www.instagram.com/littlerideke/" },
      ],
    },
    somalia: {
      flag: "/assets/images/Flag_of_Somalia.svg.png",
      code: "SO",
      name: "Somalia",
      location: "Mogadishu, Somalia",
      fullAddress: "Mogadishu, Somalia",
      email: "littlesom@little.africa",
      phone: "3838",
      // social: ["linkedin", "facebook", "twitter", "instagram"],
      social: [
        { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
        { facebook: "https://www.facebook.com/LittleAppKE/" },
        { twitter: "https://www.instagram.com/littlerideke/" },
        { instagram: "https://www.instagram.com/littlerideke/" },
      ],
    },
    senegal: {
      flag: "/assets/images/Flag_of_Senegal.svg.png",
      code: "SN",
      name: "Senegal",
      location: "Dakar, Senegal",
      fullAddress: "Dakar, Senegal",
      email: "contact@wigo.africa",
      phone: "+221 77 744 96 96",
      // social: ["linkedin", "twitter"],
      social: [
        { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
        { twitter: "https://www.instagram.com/littlerideke/" },
      ],
    },
    ghana: {
      flag: "/assets/images/Flag_of_Ghana.webp",
      code: "GH",
      name: "Ghana",
      location: "Accra, Ghana",
      fullAddress: "Accra, Ghana",
      email: "customer-support@little.bz",
      phone: "0507795596",
      // social: ["linkedin", "facebook", "twitter", "instagram"],
      social: [
        { linkedin: "https://www.linkedin.com/company/littlesuperapp/" },
        { facebook: "https://www.facebook.com/LittleAppKE/" },
        { twitter: "https://www.instagram.com/littlerideke/" },
        { instagram: "https://www.instagram.com/littlerideke/" },
      ],
    },
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,

      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("inside the handleSubmit", e);
    setIsLoading(true);

    setEmailResponse({ message: "", success: false });

    // Define the callback function before using it
    const authenticateUser = (data) => {
      if (data.status === 200 || data.status === 201) {
        setFormData({ fullName: "", email: "", subject: "", body: "" });
        setTicketId(data.id || data.ticketId);
        setOpenSuccessDialog(true);
        setEmailResponse({
          message: data?.message || "Your message has been sent successfully!",
          success: true,
        });
      } else {
        setEmailResponse({
          message: data?.message || "Error occurred. Please try again.",
          success: false,
        });
      }
      setIsLoading(false);
    };

    try {
      // Try direct API first
      console.log("Sending request to /customer-support with data:", {
        from: formData.email,
        fullName: formData.fullName,
        subject: formData.subject,
        message: formData.body,
      });

      sendRequest(
        {
          url: "/customer-support",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            from: formData.email,
            fullName: formData.fullName,
            subject: formData.subject,
            message: formData.body,
          },
        },
        authenticateUser
      );

      console.log("sendRequest called successfully");
    } catch (error) {
      console.error("API Error:", error);
      setEmailResponse({
        message: "Network error. Please try again.",
        success: false,
      });
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({ fullName: "", email: "", subject: "", body: "" });
    setEmailResponse({ message: "", success: false });
  };

  return (
    <section
      className="contact-form-section padding-bottom"
      id="contactFormSection"
    >
      <div className="container">
        <div className="section-title">
          <h2>Contact Us</h2>
        </div>
        <div className="contact-container">
          <div className="row align-items-stretch">
            {/* Left Side - Company Details (40%) */}
            <div className="col-lg-5 col-md-5 col-sm-12 col-12">
              <div className="contact-info-wrapper">
                <div className="company-logo">
                  <img
                    src="/assets/images/Logo.png"
                    alt="Little Logo"
                    className="img-fluid"
                  />
                </div>
                <div className="company-info">
                  {/* <h3>Get in Touch</h3>
                  <p>Ready to transform your mobility solutions? Contact us for a personalized demo and discover how Little can streamline your transportation needs.</p> */}
                  <p>
                    Little is a pan-African "everyday everything" app and one of
                    the African largest ride-hailing service companies, serving
                    cities across{" "}
                    <span className="country-text india">India</span>,{" "}
                    <span className="country-text kenya">Kenya</span>,{" "}
                    <span className="country-text uganda">Uganda</span>,{" "}
                    <span className="country-text tanzania">Tanzania</span>,{" "}
                    <span className="country-text ethiopia">Ethiopia</span>,{" "}
                    <span className="country-text somalia">Somalia</span>,{" "}
                    <span className="country-text senegal">Senegal</span>, and{" "}
                    <span className="country-text ghana">Ghana</span>. The
                    Little app offers mobility, delivery and payment solutions
                    by connecting customers to drivers and delivery agents,
                    enabling convenience and transparency for hundreds of
                    thousands of customers.
                  </p>
                  {/* Country Flags Section */}
                  <div className="country-flags-section">
                    <div className="flags-container">
                      {Object.entries(countryData).map(([key, country]) => (
                        <div
                          key={key}
                          className={`country-flag ${
                            selectedCountry === key ? "active" : ""
                          }`}
                          onMouseEnter={() => setSelectedCountry(key)}
                          title={`${country.name} (${country.code})`}
                        >
                          <img
                            src={country.flag}
                            alt={`${country.name} flag`}
                            className="flag-image"
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="contact-details">
                    <div
                      className="contact-item"
                      onClick={() =>
                        window.open(
                          `https://maps.google.com/?q=${encodeURIComponent(
                            countryData[selectedCountry].fullAddress
                          )}`,
                          "_blank"
                        )
                      }
                    >
                      <div
                        className="contact-icon"
                        onClick={() =>
                          window.open(
                            `tel:${countryData[selectedCountry].phone}`,
                            "_blank"
                          )
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="contact-text">
                        <span>{countryData[selectedCountry].location}</span>
                      </div>
                    </div>

                    <div
                      className="contact-item"
                      onClick={() =>
                        window.open(
                          `mailto:${countryData[selectedCountry].email}`,
                          "_blank"
                        )
                      }
                    >
                      <div className="contact-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="contact-text">
                        <span>{countryData[selectedCountry].email}</span>
                      </div>
                    </div>

                    {countryData[selectedCountry].phone && (
                      <div
                        className="contact-item"
                        onClick={() => {
                          // Create a temporary link element for better protocol handling
                          const link = document.createElement("a");
                          link.href = `tel:${countryData[selectedCountry].phone}`;
                          link.click();
                        }}
                      >
                        <div className="contact-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <div className="contact-text">
                          <span>{countryData[selectedCountry].phone}</span>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Social Media Icons */}
                  <div className="social-media-section">
                    <div className="social-icons">
                      <a
                        href="https://www.instagram.com/littlerideke/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon instagram"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>

                      <a
                        href="https://www.facebook.com/LittleAppKE/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon facebook"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>

                      <a
                        href="https://x.com/littleappkenya/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon twitter"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>

                      <a
                        href="https://www.linkedin.com/company/littlesuperapp/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon linkedin"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                            fill="currentColor"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Contact Form (60%) */}
            <div className="col-lg-7 col-md-7 col-sm-12 col-12">
              <div className="contact-form-wrapper">
                <div className="form-header">
                  {/* <h2>Send us a Message</h2>
                  <p>Fill out the form below and we'll get back to you as soon as possible.</p> */}
                  <h3>Get in Touch</h3>
                  <p>
                    Ready to transform your mobility solutions? Contact us for a
                    personalized demo and discover how Little can streamline
                    your transportation needs.
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="contact-form">
                  {/* Response Message */}
                  {emailResponse.message && (
                    <div
                      className={`form-response ${
                        emailResponse.success ? "success" : "error"
                      }`}
                    >
                      {emailResponse.message}
                      {ticketId && <p>Ticket ID: {ticketId}</p>}
                    </div>
                  )}

                  <div className="form-fields">
                    <div className="form-row">
                      <div className="form-group">
                        <label htmlFor="fullName">Full Name *</label>
                        <input
                          type="text"
                          id="fullName"
                          name="fullName"
                          value={formData.fullName}
                          onChange={handleInputChange}
                          required
                          disabled={isLoading}
                          placeholder="Enter your full name"
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="email">Email *</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          disabled={isLoading}
                          placeholder="your email address"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="subject">Subject *</label>
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                        disabled={isLoading}
                        placeholder="Enter the subject of your inquiry"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="body">Message *</label>
                      <textarea
                        id="body"
                        name="body"
                        value={formData.body}
                        onChange={handleInputChange}
                        required
                        disabled={isLoading}
                        rows="4"
                        placeholder="Enter your message here..."
                      ></textarea>
                    </div>
                  </div>

                  <div className="form-buttons">
                    {/* <button
                    type="button" 
                    onClick={handleCancel} 
                    className="cancel-btn"
                    disabled={isLoading}
                  >
                    Cancel

                    </button> */}
                    <button
                      type="submit"
                      className="submit-btn"
                      disabled={isLoading}
                    >
                      {isLoading ? "Sending..." : "Send Message"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Success Popup Modal */}
      {openSuccessDialog && (
        <div
          className="modal-overlay"
          onClick={() => setOpenSuccessDialog(false)}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Message Sent Successfully!</h3>
              <button
                className="modal-close"
                onClick={() => setOpenSuccessDialog(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <p>Thank you for contacting us. We will get back to you soon.</p>
              {ticketId && (
                <div className="ticket-info">
                  <strong>Your Ticket ID: {ticketId}</strong>
                  <p>Please keep this ID for your reference.</p>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                className="btn-primary"
                onClick={() => setOpenSuccessDialog(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

function FloatingChatWidget() {
  const scrollToContactForm = () => {
    const contactSection = document.getElementById("contactFormSection");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="floating-chat-widget" onClick={scrollToContactForm}>
      <div className="chat-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
            fill="white"
          />
          <path d="M7 9H17V11H7V9ZM7 12H15V14H7V12Z" fill="white" />
        </svg>
      </div>
      <div className="chat-text">
        <span>Contact Us</span>
      </div>
    </div>
  );
}



